import { BadgeUnlockNotifications } from './BadgeUnlockNotifications';
import { PetUnlockNotifications } from './PetUnlockNotifications';
import { PetDropNotifications } from './PetDropNotifications';
import { ItemDropNotifications } from './ItemDropNotifications';

export function AllNotifications() {
  return (
    <>
      <BadgeUnlockNotifications />
      <PetUnlockNotifications />
      <PetDropNotifications />
      <ItemDropNotifications />
    </>
  );
}

export { BadgeUnlockNotifications, PetUnlockNotifications, PetDropNotifications, ItemDropNotifications };